import React from 'react';
import Heading from 'components/atoms/text/heading';
import BackButton from 'components/atoms/back-button';
import { CommonOrganismProps } from '../types';

interface Props extends CommonOrganismProps {
  children: React.ReactNode;
}

export default function Section({ title, children, styles, onBackButtonClick }: Props) {
  return (
    <div
      style={{ backgroundColor: 'rgb(275,275,275,0.03)' }}
      className={`flex flex-col justify-start w-full p-4 rounded-xl text-start px-4 sm:px-8 ${styles}`}>
      {onBackButtonClick && <BackButton onClick={onBackButtonClick} />}
      {title && <Heading wrapText text={title} styles="mb-2" />}
      {children}
    </div>
  );
}
